import { t } from "i18next";

export type TenantTypeID = "internal" | "external" | "public";
export type TenantType = {
  id: TenantTypeID;
  name: string;
};
export const AllTenantTypes: TenantType[] = [
  { id: "internal", name: t("main.tenantTypes.internal") },
  { id: "external", name: t("main.tenantTypes.external") },
  { id: "public", name: t("main.tenantTypes.public") },
];

